import { SET_ACTIVE_ACCOUNT_FORM_PANEL } from "./account.actionTypes";

export const setActiveAccountFormPanel = payload => ({
  type: SET_ACTIVE_ACCOUNT_FORM_PANEL,
  payload
});
